import { useContext } from 'react';
import { AlertContext } from './alert-provider';
import { AlertContextProps } from '../types';

export const useAlerts = (): AlertContextProps => {
  return useContext(AlertContext);
};
